// Inbound-Draft spec 2026-11-03 §6: "hasChanges" of the draft editor. react-hook-form's
// `isDirty` only reacts to registered fields and `setValue(..., { shouldDirty })` — the
// configurator writes date, partner, packages and lines through plain `setValue`, so
// the edit buffer is compared against a snapshot of the last reset instead.
const IGNORED_KEYS = new Set(['page', 'limit', 'offset', 'total_pages', 'line_count']);

const normalize = (value: unknown): unknown => {
  if (Array.isArray(value)) return value.map(normalize);
  if (value && typeof value === 'object') {
    return (
      Object.keys(value as Record<string, unknown>)
        // null and undefined both mean "not set" (the form holds null after a reset,
        // undefined before a field was ever touched)
        .filter(key => !IGNORED_KEYS.has(key) && (value as Record<string, unknown>)[key] != null)
        .sort()
        .reduce<Record<string, unknown>>((acc, key) => {
          acc[key] = normalize((value as Record<string, unknown>)[key]);
          return acc;
        }, {})
    );
  }
  return value ?? null;
};

export const serializeInboundFormValues = (values: unknown): string => JSON.stringify(normalize(values));

export const isInboundFormDirty = (snapshot: string, values: unknown): boolean =>
  snapshot !== '' && serializeInboundFormValues(values) !== snapshot;
